import {HomeLocationProps} from 'src/components/elements/descriptor/DescriptorType';
import Styles from '../../../Styles';
import {
  Dimensions,
  Image,
  Platform,
  Pressable,
  StyleSheet,
  Text,
  View,
} from 'react-native';
import RefiveLocationMarker from 'src/components/img/svg/RefiveLocationMarker';
import AVText from 'src/components/elements/AVText';
import FontAwesome5Pro from 'react-native-vector-icons/FontAwesome5Pro';
import NotificationUnReadIconRefive from 'src/components/img/svg/newui/notificationUnReadLogoRefive';
import NotificationReadIconRefive from 'src/components/img/svg/newui/notificationReadLogoRefive';
import Localized from 'src/constants/AppStrings';
import GreetingsAndBalanceView from 'src/components/elements/home/GreetingsAndBalanceView';
import RefiveHomeIcon from 'src/components/img/svg/RefiveHomeIcon';
import {RewardsWrappedComponent} from 'src/components/screens/home/RewardsHoc';
import {getLayoutDescriber} from 'src/components/elements/layoutDescriptor/DescriptorType';
import MilkIcon from 'src/components/img/svg/newui/milk';
import CoolDrinkIcon from 'src/components/img/svg/newui/cooldrink';
import AwarenessIcon from 'src/components/img/svg/newui/awareness';
import FruitIcon from 'src/components/img/svg/newui/fruit';
import {
  quickAddOnsPointsTextStyleDescriptor,
  quickAddOnsProductImageContainerStyleDescriptor,
  quickAddOnsTextStyleDescriptor,
  quickAddOnsViewContainerStyleDescriptor,
} from '../../../elements/cart/descriptor/cart-elements-redesign';
import React from 'react';
import {RenderRecommendationsListProps} from './types';
import RefiveMenuItemBoilerPlate from '../../../img/svg/menuItemsBoilerplateIcons/RefiveMenuItemBoilerPlate';
import Util from '../../../../Util';
import AccountStore from '../../../../stores/AccountStore';

const width = Dimensions.get('window').width;

export function getCampusLocationStyles(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    campusView: {
      flexDirection: 'row',
      maxWidth: '80%',
      justifyContent: 'flex-start',
      alignItems: 'flex-end',
      marginLeft: Styles.Spacing.m3,
      marginRight: Styles.Spacing.m4,
      minHeight: Styles.MinTouchableArea,
      marginBottom: 10,
    },
    linkLocationBtnStyle: {
      fontSize: getLayoutDescriber().bodyFontSize(),
      fontWeight: '700',
      color: '#3070ED',
      textDecorationLine: 'none',
      fontFamily: Styles.FontFamily.figtreeRegular,
    },
    linkView: {
      alignSelf: 'flex-start',
      borderBottomColor: '#066DFF',
      borderBottomWidth: 1.5,
    },
    descriptionText: {
      fontFamily: Styles.FontFamily.figtreeRegular,
    },
  };
}

export function backGroundColorHomeScreen(): string {
  return Styles.white;
}
export function locationHeaderName(): string {
  return Localized.Labels.locations.toUpperCase();
}

export function linkLocationDropDown(props?: HomeLocationProps): JSX.Element {
  return (
    <>
      <View style={homeLocationHeaderStyleDescriptor()['locationMainView']}>
        <RefiveLocationMarker />
      </View>
      <AVText
        style={[
          homeLocationHeaderStyleDescriptor()['campusNameText'],
          homeLocationHeaderStyleDescriptor()['locationText365'],
        ]}
        numberOfLines={1}
        maxFontSizeMultiplier={Styles.FontSizeMultiplier.maxfm1}
      >
        {props.locationNameText}
      </AVText>
      <FontAwesome5Pro
        accessible={true}
        accessibilityLabel={
          'Down arrow icon, Double tap to the Locations Screen'
        }
        aria-label={'Down arrow icon, Double tap to the Locations Screen'}
        name="chevron-down"
        color={Styles.Colors.PayNew.white01}
        size={Styles.Heights.touchTargetHeight0}
        style={[homeLocationHeaderStyleDescriptor()['campusArrow']]}
        testID="qa_dpd_SelectLocation"
      />
    </>
  );
}

export function recommendationsBlockRenderItem({
  item,
  index,
  isFirstItem,
  isLastItem,
  onMenuItemPress,
}: RenderRecommendationsListProps): JSX.Element {
  return (
    <Pressable
      role="button"
      onPress={() => onMenuItemPress(item)}
      key={index}
      accessibilityRole="button"
      style={{
        ...(Platform.OS === 'web' ? {} : styles.shadow),
      }}
    >
      <View
        accessible
        style={[
          quickAddOnsViewContainerStyleDescriptor(),
          isFirstItem && styles.firstItem,
          isLastItem && styles.lastItem,
        ]}
      >
        <View>
          {/*<Pressable*/}
          {/*  style={quickAddOnsProductPlusIconStyleDescriptor()}*/}
          {/*  onPress={() => onMenuItemPress(item, true)}*/}
          {/*  hitSlop={Styles.HitSlop_4}*/}
          {/*>*/}
          {/*  <PlusSignIcon />*/}
          {/*</Pressable>*/}
          {item.imageUrl ? (
            <Image
              accessible={true}
              accessibilityLabel="Product image"
              accessibilityRole="image"
              aria-label="Product image"
              role="img"
              style={quickAddOnsProductImageContainerStyleDescriptor()}
              source={{uri: item.imageUrl}}
              resizeMode={'cover'}
            />
          ) : (
            getPlaceholderImage()
          )}
        </View>
        <Text
          style={[quickAddOnsTextStyleDescriptor(), styles.font]}
          accessibilityHint="Recommendations product name"
          accessibilityLabel={`${item.productName} product name`}
          aria-label={`${item.productName} product name`}
        >
          {item?.productName}
        </Text>
        <Text
          style={[quickAddOnsPointsTextStyleDescriptor(), styles.font]}
          accessibilityHint="Recommendations product price"
          accessibilityLabel={`${item.productName} product price`}
          aria-label={`${item.productName} product price`}
        >
          {Util.formatCurrency(null, +item.price, AccountStore.getCurrency())}
        </Text>
      </View>
    </Pressable>
  );
}

export function getPlaceholderImage() {
  return <RefiveMenuItemBoilerPlate />;
}

export function greetingBalanceRewardsView(
  shortcutBar: JSX.Element,
  _data?: {
    [index: string]: {[index: string]: number | string};
  },
  _location?: string,
  trackerSlot?: JSX.Element,
): JSX.Element {
  return (
    <>
      <View style={[homeLocationHeaderStyleDescriptor()['homeRefiveLogo']]}>
        <RefiveHomeIcon width={width - Styles.Spacing.m3 * 2} />
      </View>
      {shortcutBar}
      {trackerSlot}
      <GreetingsAndBalanceView />
      <RewardsWrappedComponent data={_data} />
    </>
  );
}
export function getLocationEmptyIcons() {
  return {
    milk: <MilkIcon fill={getLayoutDescriber().primaryColor()} />,
    coolDrink: <CoolDrinkIcon fill={getLayoutDescriber().primaryColor()} />,
    awareness: <AwarenessIcon fill={getLayoutDescriber().primaryColor()} />,
    fruit: <FruitIcon fill={getLayoutDescriber().primaryColor()} />,
  };
}
export function readUnreadNotificationIcon(
  props?: HomeLocationProps,
): JSX.Element {
  return (
    <>
      <View style={homeLocationHeaderStyleDescriptor()['locationMainView']}>
        {props.readOrUnreadNotificaton ? (
          <NotificationUnReadIconRefive />
        ) : (
          <NotificationReadIconRefive />
        )}
      </View>
    </>
  );
}

export function getScanProductName(): string {
  return Localized.Labels.scan_product_capital;
}

export function getScanProductBtnStyle(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    applyButtonText: {
      fontFamily: Styles.FontFamily.figtreeRegular,
      fontSize: getLayoutDescriber().bodyFontSize(),
      textAlign: 'right',
      fontWeight: '700',
    },
  };
}

export function homeLocationHeaderStyleDescriptor(): {
  [index: string]: {[index: string]: number | string};
} {
  return {
    campusNameText: {
      marginLeft: Styles.Spacing.m2 - 2,
      fontSize: getLayoutDescriber().bodyFontSize(),
      maxWidth: '100%',
      color: Styles.white,
      flexShrink: 1,
      fontFamily: Styles.FontFamily.comodoVintage,
    },
    campusArrow: {
      marginLeft: Styles.Spacing.m2,
      marginTop: 2,
    },
    locationMainView: {
      marginBottom: 3,
    },
    locationText365: {
      color: Styles.white,
      fontFamily: Styles.FontFamily.comodoVintage,
      fontSize: getLayoutDescriber().headerFontSize(),
    },
    homeRefiveLogo: {
      marginTop: Styles.Spacing.m3,
      alignItems: 'center',
      justifyContent: 'center',
      marginBottom: Styles.Spacing.m1,
    },
  };
}

export function shortCutButtonBorderColor(): string {
  return Styles.Colors.PayNew.brightGray;
}

const styles = StyleSheet.create({
  firstItem: {
    marginLeft: Styles.Spacing.m3,
  },
  shadow: {
    shadowColor: '#000',
    shadowOffset: {width: 2, height: 4},
    shadowOpacity: 0.08,
    shadowRadius: 2,
    elevation: 2,
    marginBottom: Styles.Spacing.m1,
    minHeight: Styles.MinTouchableArea,
  },
  lastItem: {
    marginRight: Styles.Spacing.m3,
  },
  font: {
    fontFamily: Styles.FontFamily.gothamRegular,
    color: Styles.Colors.PayNew.black01,
  },
  quickAdd: {
    backgroundColor: Styles.Colors.Aramark.black01,
    alignItems: 'center',
    borderRadius: Styles.Spacing.m2,
    justifyContent: 'center',
    borderColor: Styles.Colors.PayNew.neutralHuesBase09,
    alignSelf: 'center',
    width: 110,
    height: 110,
  },
});

export default {
  getScanProductName,
  getScanProductBtnStyle,
  getCampusLocationStyles,
  homeLocationHeaderStyleDescriptor,
  linkLocationDropDown,
  backGroundColorHomeScreen,
  getLocationEmptyIcons,
  greetingBalanceRewardsView,
  readUnreadNotificationIcon,
  locationHeaderName,
  getTrackerPlacement: () => 'belowTitle',
  shortCutButtonBorderColor,
  recommendationsBlockRenderItem,
  getPlaceholderImage,
};
